export enum CsszSickNoteFillingTypeEnum {
    RDPN1 = 'RDPN1',
    RDPN1_CORRECTION = 'RDPN1_CORRECTION',
    RDPN3 = 'RDPN3',
    PTDPN = 'PTDPN',
    HOL = 'HOL',
    ZOLUSOU = 'ZOLUSOU',
    ZPNPUS = 'ZPNPUS',
    ZUSPVY = 'ZUSPVY',
    ZOLUSU = 'ZOLUSU',
}
